import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DeadlineCotractApi } from '@api/deadlineContract.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { MaintenanceTypeService } from '@core/components/inputs/maintenance-type/maintenance-type.service';
import { TimeValidation } from '@core/validators/time-validation';
import { ConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import brAddressFormatter from 'br-address-formatter';
import { merge } from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabMaintenanceComponent = /** @class */ (function () {
    function TabMaintenanceComponent(data, fuseTranslationLoaderService, maintenanceTypeService, formBuilder, matDialog, authenticationService, deadlineContractApi, translateService) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.maintenanceTypeService = maintenanceTypeService;
        this.formBuilder = formBuilder;
        this.matDialog = matDialog;
        this.authenticationService = authenticationService;
        this.deadlineContractApi = deadlineContractApi;
        this.translateService = translateService;
        this.isViewMode = false;
        this.isClosedMaintenance = false;
        this.problems = [];
        this.addressCoords = null;
        this.maintenanceTypes = [];
        this.validStatusToEditMaintenance = ['new', 'requested', 'onNegotiation'];
        this.getMaintenanceForm = new EventEmitter();
        this.isLoading = new EventEmitter();
        this.whereSegments = { archived: false };
        this.whereProblems = { archived: false };
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
        this.destroyed = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.maintenance = data.maintenance;
        this.isViewMode = data.isViewMode;
    }
    TabMaintenanceComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.maintenance.scheduled && this.maintenance.scheduled.date) {
            this.maintenance.scheduledAt = this.maintenance.scheduled.date;
        }
        if (this.maintenance.scheduled && this.maintenance.scheduled.time) {
            this.maintenance.scheduledAt += "T" + this.maintenance.scheduled.time;
        }
        this.isClosedMaintenance = this.maintenance.status === 'done' || this.maintenance.status === 'canceled';
        this.maintenancesForm = this.formBuilder.group({
            id: this.maintenance.id ? this.maintenance.id : null,
            number: new FormControl({ value: this.maintenance.number, disabled: true }),
            segment: new FormControl(this.maintenance.segment, Validators.required),
            problemId: new FormControl(this.maintenance.problem && this.maintenance.problem.id),
            typeId: new FormControl((this.maintenance.maintenanceType && this.maintenance.maintenanceType.id), Validators.required),
            message: new FormControl(this.maintenance.message, [Validators.required, Validators.maxLength(2000)]),
            status: this.maintenance.status || 'new',
            weight: new FormControl(this.maintenance.weight || 1, [Validators.required, Validators.min(1), Validators.max(5)]),
            locationId: [(this.maintenance.location && this.maintenance.location.id), Validators.required],
            address: this.maintenance.address ? this.formBuilder.group(tslib_1.__assign({}, this.maintenance.address, { formattedAddress: brAddressFormatter(this.maintenance.address) }), Validators.required) : this.formBuilder.group({ formattedAddress: null }),
            openedDate: {
                value: this.maintenance.openedAt ? moment(this.maintenance.openedAt).toDate() : null,
                disabled: true
            },
            openedTime: {
                value: this.maintenance.openedAt ? moment(this.maintenance.openedAt).format('HH:mm') : null,
                disabled: true
            },
            scheduleSuggestions: this.maintenance.scheduleSuggestions.length > 0 ? new FormArray(this.maintenance.scheduleSuggestions.map(function (scheduleSuggestion) { return new FormControl(scheduleSuggestion); })) : new FormArray([]),
            scheduleSuggestionsStatus: this.maintenance.scheduleSuggestionsStatus ? this.maintenance.scheduleSuggestionsStatus : null,
            companyScheduleSuggestion: this.maintenance.companyScheduleSuggestion ? this.maintenance.companyScheduleSuggestion : null,
            scheduleSuggestionsWasChanged: false,
        });
        this.maintenancesForm.get('segment').valueChanges.subscribe(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setMaintenacesType()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        if (this.maintenance.deadlineContract) {
            var responseDeadlineViolationReason = this.maintenance.deadlineContract.responseDeadlineViolationReason && this.maintenance.deadlineContract.responseDeadlineViolationReason.deadlineViolationReason;
            var solutionDeadlineViolationReason = this.maintenance.deadlineContract.solutionDeadlineViolationReason && this.maintenance.deadlineContract.solutionDeadlineViolationReason.deadlineViolationReason;
            this.maintenancesForm.addControl('responseDeadlineViolationReason', new FormControl(responseDeadlineViolationReason));
            this.maintenancesForm.addControl('solutionDeadlineViolationReason', new FormControl(solutionDeadlineViolationReason));
        }
        if (this.maintenance.problem && this.maintenance.problem.id) {
            this.problems = [this.maintenance.problem];
            this.maintenancesForm.get('problemId').setValue(this.maintenance.problem.id);
        }
        if (!this.maintenancesForm.get('address').get('formattedAddress').value && this.maintenance.location &&
            this.maintenance.location.address && this.maintenance.location.address.formattedAddress) {
            this.maintenancesForm.get('address').get('formattedAddress').setValue(this.maintenance.location.address.formattedAddress);
        }
        this.maintenancesForm.addControl('requesterId', new FormControl({
            value: this.maintenance.requester && this.maintenance.requester.id,
            disabled: true
        }, Validators.required));
        this.maintenancesForm.addControl('assignee', new FormControl(this.maintenance.assignee));
        this.maintenancesForm.addControl('company', new FormControl(this.maintenance.company));
        this.maintenancesForm.addControl('deadlineContract', new FormControl(this.maintenance.deadlineContract && this.maintenance.deadlineContract.originalContract || null));
        if (!this.validStatusToEditMaintenance.includes(this.maintenance.status)) {
            this.maintenancesForm.get('deadlineContract').disable();
        }
        this.subscribeToDeadlineContract();
        this.maintenancesForm.addControl('statusDescription', new FormControl({
            value: this.maintenance.statusDescription,
            disabled: this.maintenance.company && this.maintenance.company.fieldAccountId ? true : false
        }, Validators.required));
        if (this.isViewMode) {
            this.maintenancesForm.disable();
        }
        this.maintenancesForm.valueChanges.subscribe(function () {
            _this.getMaintenanceForm.emit(_this.maintenancesForm);
        });
        this.maintenancesForm.get('status').valueChanges.subscribe(function (value) {
            _this.isClosedMaintenance = value === 'done' || value === 'canceled';
            var companyUsesFieldControl = _this.maintenance.company && _this.maintenance.company.fieldAccountId;
            if (_this.isClosedMaintenance) {
                _this.maintenancesForm.addControl('closedDate', new FormControl({
                    value: _this.maintenance.closedAt ? moment(_this.maintenance.closedAt).toDate() : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.addControl('closedTime', new FormControl({
                    value: _this.maintenance.closedAt ? moment(_this.maintenance.closedAt).format('HH:mm') : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.addControl('startDate', new FormControl({
                    value: _this.maintenance.firstVisitStartedAt ? moment(_this.maintenance.firstVisitStartedAt).toDate() : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.addControl('startTime', new FormControl({
                    value: _this.maintenance.firstVisitStartedAt ? moment(_this.maintenance.firstVisitStartedAt).format('HH:mm') : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.addControl('statusDescription', new FormControl({
                    value: _this.maintenance.statusDescription,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.setValidators(TimeValidation.validate.bind(_this));
            }
            if (value !== 'new' && value !== 'pending') {
                _this.maintenancesForm.addControl('scheduledDate', new FormControl({
                    value: (_this.maintenance.scheduled && _this.maintenance.scheduled.date) ? moment(_this.maintenance.scheduledAt).toDate() : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.addControl('scheduledTime', new FormControl({
                    value: (_this.maintenance.scheduled && _this.maintenance.scheduled.time) ? moment(_this.maintenance.scheduledAt).format('HH:mm') : null,
                    disabled: companyUsesFieldControl
                }));
                _this.maintenancesForm.setValidators(TimeValidation.validate.bind(_this));
            }
            if (value === 'new' || value === 'pending') {
                _this.maintenancesForm.removeControl('scheduledDate');
                _this.maintenancesForm.removeControl('scheduledTime');
                _this.maintenancesForm.removeControl('closedDate');
                _this.maintenancesForm.removeControl('closedTime');
                _this.maintenancesForm.removeControl('startDate');
                _this.maintenancesForm.removeControl('startTime');
                _this.maintenancesForm.removeControl('statusDescription');
                _this.maintenancesForm.setValidators(null);
            }
        });
        this.shouldShowScheduleSuggestion = this.shouldShowScheduleSuggestionElement();
        this.isLoading.pipe(takeUntil(this.destroyed)).subscribe(function () {
            _this.shouldShowScheduleSuggestion = _this.shouldShowScheduleSuggestionElement();
        });
        this.getMaintenanceCoords();
    };
    TabMaintenanceComponent.prototype.ngOnDestroy = function () {
        this.destroyed.next();
        this.destroyed.complete();
    };
    TabMaintenanceComponent.prototype.setMaintenacesType = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var segment, segmentHasMaintenanceTypesSeted;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        segment = this.maintenancesForm.get('segment').value;
                        segmentHasMaintenanceTypesSeted = segment.maintenanceTypes && segment.maintenanceTypes.length > 0;
                        return [4 /*yield*/, this.maintenanceTypeService.listMaintenanceTypes({
                                where: {
                                    archived: false,
                                    segmentId: segmentHasMaintenanceTypesSeted ? this.maintenancesForm.get('segment').value.id : null,
                                }
                            }).then(function (maintenanceTypes) {
                                _this.maintenanceTypes = maintenanceTypes;
                                var currentMaintenanceTypeIsOnList = _this.maintenanceTypes.some(function (maintenanceType) {
                                    return maintenanceType.id === _this.maintenance.maintenanceType.id;
                                });
                                if (!currentMaintenanceTypeIsOnList) {
                                    _this.maintenanceTypes.push(_this.maintenance.maintenanceType);
                                }
                                _this.maintenancesForm.updateValueAndValidity();
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabMaintenanceComponent.prototype.shouldShowScheduleSuggestionElement = function () {
        var maintenanceStatus = this.maintenancesForm.get('status');
        var scheduleSuggestionsStatus = this.maintenancesForm.get('scheduleSuggestionsStatus');
        var isValidStatusesToShow = Boolean(maintenanceStatus.value === 'new' ||
            maintenanceStatus.value === 'requested' ||
            maintenanceStatus.value === 'onNegotiation');
        var isSuggestionStopped = ((scheduleSuggestionsStatus.value && scheduleSuggestionsStatus.value === 'suggestionStopped'));
        return (isValidStatusesToShow && !isSuggestionStopped);
    };
    TabMaintenanceComponent.prototype.getWhereSegments = function () {
        if (this.maintenance && this.maintenance.id) {
            return {};
        }
        else {
            return { archived: false };
        }
    };
    TabMaintenanceComponent.prototype.getMaintenanceCoords = function () {
        if (this.maintenance) {
            var maintenanceHasAddressCoords = this.maintenance.address && this.maintenance.address.coords.latitude && this.maintenance.address.coords.longitude;
            this.addressCoords = maintenanceHasAddressCoords
                ? this.maintenance.address.coords
                : this.maintenance.location.address.coords;
        }
    };
    TabMaintenanceComponent.prototype.subscribeToDeadlineContract = function () {
        var _this = this;
        merge(this.maintenancesForm.get('typeId').valueChanges, this.maintenancesForm.get('segment').valueChanges)
            .pipe(takeUntil(this.destroyed), filter(function () {
            var hasSegment = Boolean(_this.maintenancesForm.get('segment').value);
            var hasMaintenanceType = Boolean(_this.maintenancesForm.get('typeId').value);
            var typeChanged = _this.maintenancesForm.get('typeId').value !== _this.data.maintenance.maintenanceType.id;
            var segmentChanged = _this.maintenancesForm.get('segment').value.id !== _this.data.maintenance.segment.id;
            var typeOrSegmentChanged = typeChanged || segmentChanged;
            return (hasSegment && hasMaintenanceType && typeOrSegmentChanged);
        }), switchMap(function () {
            return _this.deadlineContractApi.getDeadlineContractByConfig({
                maintenanceTypeId: _this.maintenancesForm.get('typeId').value,
                segmentId: _this.maintenancesForm.get('segment').value.id,
                locationId: _this.maintenancesForm.get('locationId').value
            });
        }))
            .subscribe(function (receivedDeadlineContract) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var currentDeadlineContract, receivedDeadlineContractIsDifferentThanCurrent, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!receivedDeadlineContract) {
                            return [2 /*return*/];
                        }
                        currentDeadlineContract = this.maintenancesForm.get('deadlineContract').value;
                        if (!currentDeadlineContract) {
                            this.maintenancesForm.get('deadlineContract').setValue(receivedDeadlineContract);
                            return [2 /*return*/];
                        }
                        receivedDeadlineContractIsDifferentThanCurrent = currentDeadlineContract.id !== receivedDeadlineContract.id;
                        if (!receivedDeadlineContractIsDifferentThanCurrent) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.matDialog.open(ConfirmDialogComponent, {
                                data: {
                                    title: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.TITLE'),
                                    message: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.MESSAGE'),
                                    okText: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.OK_TEXT'),
                                    cancelText: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.CANCEL_TEXT')
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        this.maintenancesForm.get('deadlineContract').setValue(receivedDeadlineContract);
                        return [2 /*return*/];
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    return TabMaintenanceComponent;
}());
export { TabMaintenanceComponent };
